<template>
    <div class="bg-light mt-3 px-md-4 px-3 py-2">
        <div>
            <div>
                <h5>Nuevo estado de denuncia</h5>
            </div>

            <div v-if="errors.length">
                <el-alert type="error">
                    <ul class="mb-0">
                        <li v-for="(error, index) in errors" v-bind:key="index">
                            {{ error.message }}
                        </li>
                    </ul>
                </el-alert>
            </div>

            <el-form
                class="col w-100 p-0"
                id="local_form"
                ref="ruleForm"
                :rules="rules"
                :model="statusLocal"
                @submit.prevent="submitForm('ruleForm')"
                status-icon
            >
                <div class="d-flex justify-content-between mx-0">
                    <el-form-item class="w-100 ps-0" prop="name" id="name">
                        <el-input
                            v-model="statusLocal.name"
                            placeholder="Ingrese el nuevo estado"
                        />
                    </el-form-item>

                    <div>
                        <el-button
                            @click.prevent="submitForm('ruleForm')"
                            type="primary"
                        >
                            {{ isEdition ? "Actualizar" : "Guardar" }}
                        </el-button>
                    </div>
                </div>
            </el-form>
        </div>

        <!-- ------------------------------------------------------------- -->

        <div class="row w-100 mx-0">
            <el-table
                :data="statusList"
                style="width: 100%; height: 100%"
                max-height="500"
                :default-sort="{ prop: 'id', order: 'ascending' }"
                v-loading="waiting"
            >
                <el-table-column prop="id" label="Cód" width="90" sortable>
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="Nombre"
                    min-width="250"
                    sortable
                >
                </el-table-column>

                <el-table-column label="Activo" min-width="200">
                    <template slot-scope="props">
                        <el-switch
                            class="align-items-center switch-compact switch"
                            @change="changeEstate(props.row, props.$index)"
                            :value="props.row.active == 1"
                            active-text="Activo"
                            inactive-text="Inactivo"
                        >
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column
                    class-name="item-center"
                    fixed="right"
                    label="Acciones"
                    min-width="100"
                >
                    <template slot-scope="props">
                        <el-button
                            size="small"
                            @click="edit(props.row, props.$index)"
                            :type="
                                isEdition && props.$index == index
                                    ? 'warning'
                                    : 'primary'
                            "
                            :icon="
                                isEdition && props.$index == index
                                    ? 'el-icon-close'
                                    : 'el-icon-edit'
                            "
                        />
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    props: ["status"],
    data() {
        return {
            statusLocal: {
                id: "",
                name: "",
            },
            statusList: this.status,
            isEdition: false,
            index: null,
            errors: [],
            waiting: false,
            rules: {
                name: [
                    {
                        required: true,
                        message: "Debe escribir nombre del nuevo estatus",
                        trigger: ["change", "blur"],
                    },
                ],
            },
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid, rules) => {
                if (valid) {
                    this.submit();
                } else {
                    this.goToError(rules);
                }
            });
        },
        edit(row, index) {
            const { id, name, active } = row;
            if (this.isEdition) {
                this.isEdition = false;
                this.clearForm();
                this.index = null;
            } else {
                this.isEdition = true;
                this.statusLocal = {
                    id,
                    name,
                    active,
                };
                this.index = index;
            }
        },
        changeEstate(row, index) {
            this.statusLocal = row;
            this.statusLocal.active = !row.active;
            this.index = index;
            this.submitEdit();
        },
        submit() {
            this.errors = [];
            if (this.isEdition) {
                this.submitEdit();
            } else {
                this.submitCreate();
            }
        },
        submitCreate() {
            this.waiting = true;
            const url = `${window.location.origin}/complaint-state`;
            axios
                .post(url, { ...this.statusLocal, active: 1 })
                .then((res) => {
                    this.waiting = false;
                    this.statusList.push(res.data.person);
                    this.clearForm();
                    this.$message({
                        message: res.data.message,
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.waiting = false;
                    if (this.truthty(error.response.data)) {
                        this.errors = [];
                        if (this.truthty(error.response.data.server)) {
                            this.$message({
                                message: error.response.data.message,
                                type: "error",
                            });
                        } else {
                            error.response.data.forEach((row) =>
                                this.errors.push({ message: row })
                            );
                        }
                    }
                    // this.error = 1;
                });
        },
        submitEdit() {
            this.waiting = true;
            const url = `${window.location.origin}/complaint-state/${this.statusLocal.id}`;
            axios
                .put(url, this.statusLocal)
                .then((res) => {
                    this.waiting = false;
                    const statusListAux = this.statusList.map((row, index) => {
                        if (index == this.index) {
                            return this.statusLocal;
                        } else return row;
                    });
                    this.statusList = this.copy(statusListAux);
                    this.isEdition = false;
                    this.clearForm();
                    this.$message({
                        message: res.data.message,
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.waiting = false;
                    this.$message({
                        message:
                            "Error en editar datos. Favor de validar e intentar nuevamente.",
                        type: "error",
                    });
                    // this.error = 1;
                });
        },
        clearForm() {
            this.statusLocal = {
                id: "",
                name: "",
            };
            this.$refs["ruleForm"].resetFields();
        },
    },
    mounted() {},
};
</script>
